import { createContext } from 'react';

export interface BookingFlowValue {
    /** Tells the flow whether the booking about to be saved is followed by the next one. */
    requestNext: (next: boolean) => void;
    /** Whether the mask starts with the focus on Material. */
    focusMaterial: boolean;
}

export const BookingFlowContext = createContext<BookingFlowValue>({
    requestNext: () => undefined,
    focusMaterial: false,
});
